module.exports = __webpack_public_path__ + "4161228396bb70e95f63b870aae21b86.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/film.png
// module id = 1041
// module chunks = 0